import { CodedProperty } from "sprint-common-web";

import { GetLanguageSpecificationByIdResponse } from "../../../common/api/orders-api/language-specification/responses/GetLanguageSpecificationByIdResponse";

export interface LanguageSpecificationDashboardItem {
    id: string;
    name: string;
    mappings: LanguageCodeMappingItem[];
}

export type LanguageReference = CodedProperty;
type SoundtrackCode = string;
type SubtitleCode = string;

export interface LanguageCodeMappingItem {
    languageId: string;
    languageName: string;
    soundtrackCode?: SoundtrackCode;
    subtitleCode?: SubtitleCode;
    isModified?: boolean;
}

export const createLanguageSpecificationDashboardItem = (
    response: GetLanguageSpecificationByIdResponse
): LanguageSpecificationDashboardItem => ({
    id: response.id,
    name: response.name,
    mappings: response.mappings.map((mapping) => {
        return {
            languageId: mapping.language.id,
            languageName: mapping.language.name,
            soundtrackCode: mapping.soundtrackCode,
            subtitleCode: mapping.subtitleCode
        };
    })
});

export const defaultLanguageSpecificationDashboardItem: LanguageSpecificationDashboardItem = {
    id: "",
    name: "",
    mappings: []
};
